// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { appConfig } from '../config/runtimeConfig';

// `appConfig.APP_API_BASE_URL` only resolves a real value from
// `window.__APP_CONFIG__` (see runtimeConfig.ts), which doesn't exist during
// SSR — so on the server it silently falls back to the local-dev default.
// Worse, the real client-facing APP_API_BASE_URL is the *public* hostname,
// which on dev/uat sits behind ingress HTTP basic auth a server-to-server
// request can't satisfy. So SSR (`src/pages/boat/+data.ts` etc.) must use a
// server-only base URL that reaches the API's in-cluster Service directly,
// read straight from `process.env` (same convention as `+Head.tsx`), falling
// back to the client base URL for local dev where no in-cluster address
// exists.
const resolveBaseUrl = (): string => {
  if (typeof window !== 'undefined') return appConfig.APP_API_BASE_URL;
  return (
    process.env.APP_INTERNAL_API_BASE_URL ||
    process.env.APP_API_BASE_URL ||
    appConfig.APP_API_BASE_URL
  );
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: resolveBaseUrl(),
    timeout: 60000,
    credentials: 'include',
    prepareHeaders: (headers) => {
      headers.set('brand', appConfig.APP_BRAND ?? '');
      return headers;
    },
  }),
  endpoints: () => ({}),
});
